// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"81594504","363":"c9c87574","634":"e0653d77","944":"b5b69e1d","945":"97a287b2"}[chunkId] + ".chunk.js";
};